<template lang="html" src="./index.html"> </template>

<script>
import axios from "axios";
import AuthUser from "@/services/api/authUser";
import userForm from "../userForm";

export default {
  data() {
    return {
      user: {},
      error: "",
      loading: false
    };
  },
  components: {
    userForm
  },
  methods: {
    validateEmail() {
      return this.user.email && this.user.email === this.user.confirmEmail;
    },
    validatePassword() {
      return this.user.password && this.user.password === this.user.confirmPassword;
    },
    signUp() {
      this.error = "";
      if (!this.validateEmail()) {
        this.error = "Email and Confirmation Email does not match";
        return;
      }
      if (!this.validateEmail()) {
        this.error = "Password and Confirmation Password does not match";
        return;
      }
      const data = {
        first_name: this.user.firstName,
        last_name: this.user.lastName,
        email: this.user.email,
        password: this.user.password
      };
      this.loading = true;
      axios.post(`${process.env.VUE_APP_API_URL}owners/free-assessment-sign-up/`, data)
        .then(() => {
          return AuthUser.login(data);
        })
        .catch((e) => {
          const { response } = e;
          if (response.status < 500) {
            this.error = "This email is already in use.";
          } else {
            this.error = "There was a server error. Our staff has been notified. Please try again later.";
          }
          throw e;
        })
        .then(() => {
          this.$router.push({name: "coachAssessmentLibrary"});
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped src="./index.less">
</style>
